import React from "react";
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { MoreHorizontal } from "lucide-react";
import { Paper, Box, Typography, Chip, IconButton } from "@mui/material";
import { green, indigo } from "@mui/material/colors";
import { SortableTaskItem } from "./TaskCard";

const KanbanColumn = ({ id, tasks, onClickTask, onRenameColumn }) => {
  const { setNodeRef } = useSortable({ id });

  return (
    <Paper
      ref={setNodeRef}
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        minWidth: 280,
        width: "100%",
        bgcolor: "background.default",
        borderRadius: 3,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        height: "100%",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        px={1}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={{ flex: 1, minWidth: 0 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              flexShrink: 0,
              bgcolor: id === "Done" ? green[500] : indigo[500],
            }}
          />
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            color="text.primary"
            noWrap
          >
            {id}
          </Typography>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onRenameColumn(id);
            }}
            sx={{ ml: "auto" }}
          >
            <MoreHorizontal size={16} />
          </IconButton>
        </Box>
        <Chip
          label={tasks.length}
          size="small"
          sx={{
            height: 20,
            fontSize: "0.7rem",
            fontWeight: "bold",
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            ml: 1,
          }}
        />
      </Box>

      <SortableContext
        items={tasks.map((t) => t.id)}
        strategy={verticalListSortingStrategy}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            minHeight: 100,
            pr: 0.5,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#e2e8f0",
              borderRadius: "3px",
            },
          }}
        >
          {tasks.map((task) => (
            <SortableTaskItem key={task.id} task={task} onClick={onClickTask} />
          ))}
        </Box>
      </SortableContext>
    </Paper>
  );
};

export default KanbanColumn;
